module.exports = __webpack_public_path__ + "img/view.d41d8cd9.svg";